import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { ButtonResponsive } from '@framework/ui/components/button/ButtonResponsive.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionCancelButton } from '../navigation/buttons/SubmissionCancelButton.tsx';
import { CardFooterButtons } from '../navigation/CardFooterButtons.tsx';
import { type ISubmissionNavigator } from '../navigation/useSubmissionNavigation.ts';
import { SubmissionMenuKey } from '../submission/hooks/SubmissionMenuKey.ts';

export interface ISubmissionBurdenCardFooterProps {
  handleNavigation: ISubmissionNavigator;
  readonly?: boolean;
  /** Se true (Backoffice), il pulsante Annulla non viene mostrato */
  isBackoffice?: boolean;
}

export function SubmissionBurdenCardFooter(
  props: ISubmissionBurdenCardFooterProps,
) {
  const { handleNavigation, readonly, isBackoffice = false } = props;

  const { t } = useTranslation();

  const canNext = useMemo(() => {
    return handleNavigation.canNext(SubmissionMenuKey.Payment);
  }, [handleNavigation]);

  return (
    <CardFooterButtons>
      <FlexRow
        right={
          <Space>
            {readonly && !isBackoffice && <SubmissionCancelButton />}
            {canNext && (
              <ButtonResponsive
                size="large"
                type="primary"
                text={t('form.avanti', 'Avanti')}
                iconRightComponent={ArrowRightOutlined}
                iconRightAriaLabel={t('form.avanti', 'Avanti')}
                onClick={() => {
                  handleNavigation.navigate(SubmissionMenuKey.Payment, 'next');
                }}
              />
            )}
          </Space>
        }
      >
        <ButtonResponsive
          size="large"
          type="default"
          text={t('form.indietro', 'Indietro')}
          iconLeftComponent={ArrowLeftOutlined}
          iconLeftAriaLabel={t('form.indietro', 'Indietro')}
          onClick={() => {
            handleNavigation.navigate(SubmissionMenuKey.Payment, 'previous');
          }}
        />
      </FlexRow>
    </CardFooterButtons>
  );
}
